(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("./modules/footer");

require("./modules/menu");

require("./modules/funcion_carousel");

require("./modules/funciones_maquetacion");

require("./modules/home_estudios");

require("./modules/estudios_estudios");

},{"./modules/estudios_estudios":2,"./modules/footer":3,"./modules/funcion_carousel":4,"./modules/funciones_maquetacion":5,"./modules/home_estudios":6,"./modules/menu":7}],2:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  var element = $(".estudios .header_estudios .imagen");
  var texto = $(".estudios .header_estudios > .texto");
  var titulo = $(".estudios .ficha_estudio .titulo");
  var descripcion = $(".estudios .ficha_estudio .descripcion");
  $(".estudios .contenedor_estudios .estudio").click(function (e) {
    $.each($(".estudios .contenedor_estudios .estudio"), function (indexInArray, estudio) {
      $(".icon", estudio).removeClass("active");
    });
    element[0].classList.add('animated', 'bounceOutLeft');
    var id_estudio = $(this).data("estudio");
    console.log(id_estudio);

    switch (id_estudio) {
      case 1:
        var imagen = "1";
        var nombre = "OCT";
        var titulo_s = 'OCT <span class="small"> (TOMOGRAFÍA DE COHERENCIA ÓPTICA) <br> </span> <span class="subtitulo"> HEIDELBERG - SPECTRALIS </span>';
        var cuerpo = "Estudio no invasivo indicado para analizar las alteraciones en la mácula y en el nervio óptico. Permite obtener imágenes de alta resolución de la microanatomía de estas estructuras.";
        break;

      case 2:
        var imagen = "2";
        var nombre = "Campimetría";
        var titulo_s = 'CAMPIMETRÍA';
        var cuerpo = "Estudio indicado para la evaluación objetiva de las alteraciones en el campo visual y seguimiento en los pacientes con glaucoma, enfermedades del nervio óptico y padecimientos neurológicos.";
        break;

      case 3:
        var imagen = "3";
        var nombre = "Ecografía";
        var titulo_s = "ECOGRAFÍA OCULAR";
        var cuerpo = "El ultrasonido ocular es de gran ayuda para la exploración del segmento posterior del ojo cuando existe opacidad de medios y está indicado para calcular el poder del lente intraocular cuando se planea una cirugía de catarata.";
        break;

      case 4:
        var imagen = "4";
        var nombre = "Topografía Corneal";
        var titulo_s = 'TOPOGRAFÍA CORNEAL <span class="subtitulo"> <br> (ORBSCAN) </span>';
        var cuerpo = "Estudio realizado para valorar de manera integral la estructura de la córnea y sus irregularidades. Técnica esencial para saber si un paciente es candidato a cirugía refractiva y adaptación de lente de contacto.";
        break;

      case 5:
        var imagen = "5";
        var nombre = "IOL Master";
        var titulo_s = "IOL MASTER";
        var cuerpo = "Estudio indicado para el cálculo de lente intraocular cuando se planea una cirugía de catarata. Este equipo emplea la biometría óptica y un método automatizado, no invasivo, de no contacto y altamente preciso para medir las características anatómicas del ojo.";
        break;

      case 6:
        var imagen = "6";
        var nombre = "Fluorangiografía";
        var titulo_s = "Fluorangiografía";
        var cuerpo = "Este estudio permite tomar fotografías del fondo de ojo utilizando un medio de contraste (fluorescencia)  y es de gran utilidad para  valorar las enfermedades vasculares de la retina y la mácula.";
        break;
    }

    texto.fadeOut("slow", function () {
      texto.text(nombre).fadeIn("slow");
    });
    titulo.fadeOut("slow", function () {
      titulo.html(titulo_s).fadeIn("slow");
    });
    descripcion.fadeOut("slow", function () {
      descripcion.html(cuerpo).fadeIn("slow");
    });
    element[0].addEventListener('animationend', function () {
      //efecto de entrada	
      element[0].classList.remove('animated', "bounceOutLeft");
      $(".estudios .header_estudios .imagen").attr("data-imagen", imagen);
      element[0].classList.add('animated', 'bounceInLeft');
    });
    $(".icon", this).addClass("active");
  });
});

},{}],3:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  $(".up").click(function (e) {
    $("html,body").stop().animate({
      scrollTop: 0
    }, 800, 'swing', function () {//callback
    });
  });
});

},{}],4:[function(require,module,exports){
"use strict";

//Ready
$(function () {
  $(".carousel").swipe({
    swipe: function swipe(event, direction, distance, duration, fingerCount, fingerData) {
      if (direction == 'left') {
        $(this).carousel('next');
      } else if (direction == 'right') {
        $(this).carousel('prev');
      }
    }
  });
}); // Termina Ready

},{}],5:[function(require,module,exports){
"use strict";

//Ready
$(function () {
  $(".blockserios").on('mousedown', function (event) {
    event.preventDefault();
    return false;
  }).on('contextmenu', function (event) {
    event.preventDefault();
    return false;
  });
});

},{}],6:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  var element = $(".home .header_estudios .imagen");
  $(".home .contenedor_estudios .estudio").click(function (e) {
    $.each($(".home .contenedor_estudios .estudio"), function (indexInArray, estudio) {
      $(".icon", estudio).removeClass("active");
    });
    element[0].classList.add('animated', 'bounceOutLeft');
    var imagen = $(this).data("img");
    element[0].addEventListener('animationend', function () {
      //efecto de entrada	
      element[0].classList.remove('animated', "bounceOutLeft");
      $(".home .header_estudios .imagen").css("background-image", "url(" + imagen + ")");
      element[0].classList.add('animated', 'bounceInLeft');
    });
    $(".icon", this).addClass("active");
  });
});

},{}],7:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  $('#menu-icon').click(function (event) {
    $('#menu-movil').toggle();
    setTimeout(function () {
      $('#menu-movil').toggleClass('active');
    }, 100);
  });
  $('.icon-close, #menu-movil a').click(function (event) {
    $('#menu-movil').toggleClass('active');
    setTimeout(function () {
      $('#menu-movil').toggle();
    }, 2000);
  });
  $("#to_up").click(function (event) {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  });
  $('.link_ubicacion').click(function () {
    $('html, body').animate({
      scrollTop: $(".ubicacion").offset().top
    }, 1000);
  });
  $('.link_hoteles').click(function () {
    $('html, body').animate({
      scrollTop: $(".hoteles").offset().top
    });
  });
  $('.link_turismo').click(function () {
    $('html, body').animate({
      scrollTop: $(".turismo").offset().top
    });
  });
  $('.link_itinerario').click(function () {
    $('html, body').animate({
      scrollTop: $(".itinerario").offset().top
    });
  });
  $('.link_alimentos').click(function () {
    $('html, body').animate({
      scrollTop: $(".alimentos").offset().top
    });
  });
  $('.link_codigo').click(function () {
    $('html, body').animate({
      scrollTop: $(".codigo").offset().top
    });
  });
  $('.link_regalos').click(function () {
    $('html, body').animate({
      scrollTop: $(".regalos").offset().top
    });
  });
  $('.link_confirmacion').click(function () {
    $('html, body').animate({
      scrollTop: $(".confirmacion").offset().top
    });
  });
});

},{}]},{},[1]);
